<template>
  <div id="faq">
    <nav-bar-top is-primary />
    <div class="container has-nav-top-margin">
      <section class="section">
        <h4 class="title is-4">
          Frequently Asked Questions
        </h4>
      </section>
      <section
        v-for="(faq, index) in faqs"
        :key="faq.key"
        class="section question-section no-pad-top"
      >
        <div class="question level level-left">
          <button
            class="button is-rounded is-primary faq-plus"
            @click="toggleFaq(index)"
          >
            <i class="fas fa-plus" />
          </button>
          <p class="has-text-weight-bold is-inline">
            {{ faq.question }}
          </p>
        </div>
        <div
          v-show="faq.isOpen"
          class="answer"
        >
          <p class="line-space-tall">
            <span v-html="faq.answer" /> <!-- eslint-disable-line vue/no-v-html -->
          </p>
        </div>
      </section>
      <section class="section">
        <h6 class="title is-6">
          Don’t see your question here?
          <a
            href="https://forms.gle/MAv856x4zR2j9XdZ8"
            target="_blank"
          >Click Here</a> to submit a question and we’ll get back to you asap.
        </h6>
      </section>
    </div>
  </div>
</template>

<script>
import NavBarTop from '@/components/Navigation/NavBarTop';
import { frequentlyAskedQuestions } from '@/helpers/constants';

export default {
  name: 'FrequentlyAskedQuestions',
  components: {
    NavBarTop
  },
  data () {
    return {
      faqs: [] // FAQs imported from constants file.
    };
  },
  created () {
    this.faqs = frequentlyAskedQuestions.FAQS;
  },
  methods: {
    toggleFaq (faqIndex) {
      this.faqs[faqIndex].isOpen = !this.faqs[faqIndex].isOpen;
    }
  }
};
</script>

<style lang="scss" scoped>
.question-section {
  padding-bottom: 1.5rem;
}

.faq-plus {
  margin-right: 1rem;
}

.line-space-tall {
  line-height: 2.25rem;
}

@media screen and (min-width: 0px) {
  .level-left {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }
}
</style>
